import * as CoreFns from '../utilities/CoreFns';
import * as StyleFunctions from '../utilities/StyleFunctions';
import {useState} from 'react';

function App(props) {

  const [showDunShow, setShowDunShow] = useState(0);

  var currentList = props.currentList;
  var postSelect = props.postSelect;
  var value = props.value;


  var smartContracts = currentList.sc;
  var smartContractKeys = Object.keys(smartContracts);
  var chainId = CoreFns.relevantChainId(currentList);
  var smartContractKeysValid = smartContractKeys.filter((aSCKey, index)=>{
    var thisSC = smartContracts[aSCKey];
    if (thisSC.addSet[chainId]){
      return true;
    }
    return false;
  })


  function onClickAddress(newAddress){
    return function(e){
      postSelect(newAddress);

    }
  }

  var smartContractRows = smartContractKeysValid.map((aSCKey, index)=>{
    var thisSC = smartContracts[aSCKey];
    var thisAddSet = thisSC.addSet[chainId];
    var style={};
    if (value === thisAddSet.addr){
      style.textDecoration = 'underline';
    }
    return <tr key={aSCKey} style={{cursor:'pointer'}} onClick={onClickAddress(thisAddSet.addr)}><td>{thisAddSet.contractName}</td><td style={style}>{StyleFunctions.shortenName(thisAddSet.addr)}</td></tr>
  })
//
//

  function toggleShowDunShow(newState){
    return function(e){
      setShowDunShow(newState);
    }
  }

  if (smartContractRows.length > 0){
    if (showDunShow){
      return <center><table>{smartContractRows}<tr><td colSpan='2' style={{cursor:'pointer'}} onClick={toggleShowDunShow(0)}>[Hide Addresses]</td></tr></table></center>
//
    }else{
      return <center><div style={{cursor:'pointer'}} onClick={toggleShowDunShow(1)}>[Show Contract Addresses]</div></center>
    }
  }
  return null
}
//

export default App;
